import React, { Component } from 'react'
import { H3, ModalHeader, ModalBody, ModalFooter, Button, Input, Form, Submit } from '@framework'
import { updateUserInfo } from '@store/actions/player.action'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

class SetNoteModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      content: '',
      playerId: props.playerDetail.Username
    }
  }

  handleInputChange (state, event) {
    this.setState({ [state]: event.target.value })
  }

  render () {
    const { updateUserInfo, modal } = this.props
    return (
      <div>
        <Form onSubmit={updateUserInfo.bind(this, this.state)}>
          <ModalHeader color='primary'>
            <H3>User Note</H3>
          </ModalHeader>
          <ModalBody>
            <Input label='Content' type='textarea' rows='4'
              onChange={this.handleInputChange.bind(this, 'content')}/>
          </ModalBody>
          <ModalFooter>
            <Submit color='success' onClick={() => modal.hide()}>Add</Submit>
            <Button onClick={() => modal.hide()}>Close</Button>
          </ModalFooter>
        </Form>
       
      </div>
    )
  }
}


export default connect(
  ({ player:
    { 
      list: { data },
      view: { listDataIndex }
    }
  }) => ({
    playerDetail: data[listDataIndex] ? data[listDataIndex] : {}
  }), 
  dispatch => bindActionCreators({
    updateUserInfo
  }, dispatch)
  )(SetNoteModal)